import { render, staticRenderFns } from "./ModalSelect.vue?vue&type=template&id=068828b0&"
import script from "./ModalSelect.vue?vue&type=script&lang=js&"
export * from "./ModalSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports